export default __webpack_public_path__ + "static/media/lab3.dc2c8310.jpeg";